<template>
  <div>
    <h1 class=" mb-4">
      Team-Management
    </h1>

    <div class="mb-4 flex flex-row">

      <div class="tracking-wide text-blue-dark">

        <router-link :to="{ name: 'teams.create' }">
          <pv-button
            label="Neues Team"
            icon="pi pi-plus"
            autofocus
          />
        </router-link>
      </div>
    </div>

    <div
      v-if="teams.length<=0"
      class="flex flex-col"
    >
      <div>
        Noch ist kein Team vorhanden.
        <router-link :to="{ name: 'teams.create' }">
          Anlegen
        </router-link>
      </div>
      <div class="mt-8">
        <router-link :to="{ name: 'teams.create' }">
          <img
            class="h-64"
            src="/static/undraw_tabs_jf82.svg"
          >
        </router-link>
      </div>
    </div>
    <div class="flex flex-wrap w-full">
      <router-link
        v-for="team in displayTeams"
        :key="team.teamId"
        :to="{name: 'teams.detail', params: { id: team.teamId} }"
        class="mt-4"
      >
        <div class="mb-4 cursor-pointer">
          <div class="w-128 rounded overflow-hidden shadow-lg">
            <img
              class="w-full cursor-pointer h-32"
              :src="resolveImage(team)"
              alt="Sunset in the mountains"
            >
            <div class="px-6 py-4">
              <div class="font-bold text-xl cursor-pointer">
                {{ team.name }}
              </div>
              <p class="text-grey-darker text-base mt-4">
                <sc-sessions-small
                  v-if="team.nextSession"
                  :session-id="team.nextSession.id"
                  :session-title="team.nextSession.title"
                  :session-date="team.nextSession.date"
                  :team-id="team.nextSession.teamId"
                  :team-name="team.nextSession.teamName"
                  :emphasis-tags="team.nextSession.tags.emphasized"
                  :participated="team.nextSession.playerReviews"
                  :total-red="team.nextSession.totalRed"
                  :total-yellow="team.nextSession.totalYellow"
                />
              </p>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import apiService from '../api/apiService'

export default {
    name: 'TeamManagement',
    data () {
        return {
            teams: []
        }
    },
    computed: {
        displayTeams: function () {
            return this.teams
        }
    },

    async mounted () {
        var teams = await apiService.getMyTeams()
        this.teams = teams.data
    },
    methods: {
        resolveImage (item) {
            if (item && item.image && item.image.length > 0) {
                return item.assets[0]
            } else {
                return '/static/undraw_tabs_jf82.svg'
            }
        }
    }

}
</script>

<style scoped>

</style>
